import React from "react";
import panda from "../../../../../../../src/assets/valuemapping.png";

const WelcomeScreen = ({ onStart }) => (
  <div className="flex flex-col items-center w-full min-h-[735px]">
    {/* Heading */}
    <div className="w-full text-left mb-12">
      <h1
        className="text-[32px] text-[#323232] tracking-tight leading-snug"
        style={{
          fontFamily: "Gotham, sans-serif",
          fontWeight: 500,
          lineHeight: "1.35",
        }}
      >
        Mapping your Values
      </h1>
    </div>

    {/* Panda Image */}
    <img
      src={panda}
      alt="Mapping Values Panda"
      style={{ width: 320, height: 333 }}
      className="mb-8 select-none pointer-events-none"
      draggable={false}
    />

    {/* Description */}
    <p
      className="text-center text-[#323232] mb-8 max-w-2xl"
      style={{
        fontFamily: "Gotham, sans-serif",
        fontWeight: 400,
        fontSize: 16,
        lineHeight: "1.65",
      }}
    >
      Now that we’ve sorted your unmet needs, let’s move to the next step. Today,
      we’ll dive into an exercise to identify your core values, essential for advancing
      your career.
    </p>

    {/* Get Started Button */}
    <button
      onClick={onStart}
      style={{
        width: 218,
        height: 69,
        borderRadius: 20,
        background: "#54B0AF",
        paddingTop: 22,
        paddingBottom: 22,
        paddingLeft: 20,
        paddingRight: 20,
        fontFamily: "Gotham, sans-serif",
      }}
      className="flex items-center justify-between text-white font-medium text-lg shadow hover:bg-teal-600 transition"
    >
      <span>Get Started</span>
      <span className="ml-4 flex items-center justify-center">
        <span
          className="flex items-center justify-center"
          style={{
            background: "#fff",
            borderRadius: "50%",
            width: 20,
            height: 20,
          }}
        >
          <svg width="18" height="18" fill="#54B0AF" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </span>
    </button>
  </div>
);

export default WelcomeScreen;
